import actions from '../../actionTypes';

export default site => {
  return {
    type: actions.ADDED_SITE,
    site
  };
};



// WEBPACK FOOTER //
// ./src/reducers/sites/actions/siteAdded.js